import { TemplateSystem } from "src/requests/templateBuilder/types";
import { RelationType, ValueShape } from "../../../globalTypes";
import { TableColumnInputType } from "../../../requests/table/types";
import { FLOWIO_LOGIN_TYPES, LOGIN_TYPES } from "./optionGetters/relationType";
import { ColumnInfo, WhereItemOptionsConfig } from "./types";

export const getDefaultRelationTypeForInputType = (
  unformattedInputType: TableColumnInputType
): RelationType => {
  switch (unformattedInputType) {
    case TableColumnInputType.DatetimeLocal:
      return RelationType.DateValueRange;
    case TableColumnInputType.DateFrom:
    case TableColumnInputType.DateTo:
      return RelationType.DateValue;
    case TableColumnInputType.Checkbox:
      return RelationType.BooleanValue;
    case TableColumnInputType.Number:
    case TableColumnInputType.Decimal:
      return RelationType.NumberValue;
    case TableColumnInputType.Text:
    default:
      return RelationType.Like;
  }
};

export const getDefaultRelationTypeForColumnInfo = (
  columnInfo: ColumnInfo
): RelationType => {
  const { unformattedInputType } = columnInfo;

  if (columnInfo.isSelect) return RelationType.SelectValue;

  if (
    columnInfo.presentationInputType === TableColumnInputType.DateFrom ||
    columnInfo.presentationInputType === TableColumnInputType.DateTo
  )
    return RelationType.DateValue;

  return getDefaultRelationTypeForInputType(unformattedInputType);
};

export const getWhereItemType = (
  colInfo: ColumnInfo,
  isRelation: boolean
): RelationType => {
  if (isRelation) return RelationType.DynamicValue;
  return getDefaultRelationTypeForColumnInfo(colInfo);
};

type Params = {
  system?: TemplateSystem;
  allowRelation?: boolean;
};

export const createWhereItemOptionsConfig = ({
  system,
  allowRelation,
}: Params): WhereItemOptionsConfig => ({
  allowRelation,
  allowLoginTypes: !!system,
  flowioLoginOnly: system === "db",
});

export const getLoginTypesForRelation = (
  optionsConfig?: WhereItemOptionsConfig
): RelationType[] => {
  if (optionsConfig?.allowLoginTypes && optionsConfig?.flowioLoginOnly)
    return FLOWIO_LOGIN_TYPES;

  if (optionsConfig?.allowLoginTypes) return LOGIN_TYPES;

  return [];
};
